import { get, post, patch } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    appcontent: {}
  },

  getters: {
    RETRIEVED_APPCONTETN: store => {
      return store.appcontent;
    }
  },

  actions: {
    getAppContents: ({ commit }, params = {}) => {
      return get('/app-contents', params).then(response => {
        return response;
      });
    },

    retrieveHtml: (_, id) => get(`/app-contents-html/${id}`),
    retrieveHtmlCategories: _ => get(`/app-contents-html-categories`),
    storeHtml: (_, data) => post('/app-contents-html', data),
    updateHtml: (_, data) => patch(`/app-contents-html/${data.id}`, data),

    retrieveIframe: (_, id) => get(`/app-contents-iframe/${id}`),
    storeIframe: (_, data) => post('/app-contents-iframe', data),
    updateIframe: (_, data) => patch(`/app-contents-iframe/${data.id}`, data),

    retrieveLink: (_, id) => get(`/app-contents-link/${id}`),
    storeLink: (_, data) => post('/app-contents-link', data),
    updateLink: (_, data) => patch(`/app-contents-link/${data.id}`, data),

    disclaimers: () => get('/app-contents-html-disclaimers'),
    administrative: () => get('/app-contents-html-administrative'),
    iframes: () => get('/app-contents-iframe'),
    retrieveAppsByContentId: (_, { params }) => {
      return get(`/applications/by-content`, params);
    }
  }
};
